var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointRecordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.532,
    height: 22.538,
    viewBox: "0 0 20.532 22.538",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9879",
    "data-name": "Group 9879",
    transform: "translate(-903 -338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-4147.71,1290H-4152a3,3,0,0,1-3-3v-12a3,3,0,0,1,3-3h9a3,3,0,0,1,3,3v6.071a7.067,7.067,0,0,0-1-.071,7.1,7.1,0,0,0-1,.071.694.694,0,0,0,0-.071.75.75,0,0,0-.749-.75h-5.5a.751.751,0,0,0-.751.75.751.751,0,0,0,.751.75h4.094a7.026,7.026,0,0,0-2.756,2.5h-1.338a.752.752,0,0,0-.751.751.751.751,0,0,0,.751.75h.619a6.982,6.982,0,0,0-.37,2.25,7.031,7.031,0,0,0,.29,2Zm-3.29-6a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-4151,1284Zm0-4a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-4151,1280Zm0-4a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0-4151,1276Zm2.751.249a.752.752,0,0,0-.751.751.751.751,0,0,0,.751.75h5.5a.75.75,0,0,0,.749-.75.751.751,0,0,0-.749-.751Z",
    transform: "translate(5058 -934)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878",
    transform: "translate(-4426.507 1859.52)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_11",
    "data-name": "Exclusion 11",
    d: "M6.533,13.045a6.526,6.526,0,1,1,2.541-.513,6.53,6.53,0,0,1-2.541.513ZM7.657,5.456h0v3h.714V4.644H7.218l-.683,2.6-.691-2.6H4.694V8.451h.714v-3l.753,3H6.9Z",
    transform: "translate(5336.975 -1512.027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointRecordIcon);
export default __webpack_public_path__ + "static/media/point-record-icon.f240dc97.svg";
export { ForwardRef as ReactComponent };